"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVpnVersion = void 0;
exports.newUserVpn = newUserVpn;
exports.getUserVpnFrom = getUserVpnFrom;
exports.jsonToUserVpn = jsonToUserVpn;
const vpn = require("./vpn");
var UserVpnVersion;
(function (UserVpnVersion) {
    UserVpnVersion[UserVpnVersion["INITIAL"] = 0] = "INITIAL";
    UserVpnVersion[UserVpnVersion["LOCATIONS"] = 1] = "LOCATIONS"; // This version introduces locations (geonames)
})(UserVpnVersion || (exports.UserVpnVersion = UserVpnVersion = {}));
function newUserVpn({ userId, geonamesId, version = UserVpnVersion.LOCATIONS, ...rest }) {
    return {
        userId,
        version,
        vpn: vpn.newVpn(geonamesId, rest.config, rest.state)
    };
}
function getUserVpnFrom({ userId, vpnId, geonamesId, createdAt, startedAt, version = UserVpnVersion.LOCATIONS, ...rest }) {
    return {
        userId,
        version,
        vpn: vpn.getVpnFrom(vpnId, createdAt, geonamesId, rest.state, rest.config, startedAt)
    };
}
function jsonToUserVpn(jsonString) {
    const parsed = JSON.parse(jsonString, (key, value) => {
        if (key === 'createdAt' || key === 'startedAt') {
            return new Date(value);
        }
        return value;
    });
    return parsed;
}
